import { AxiosResponse } from 'axios'

import customerBffFetch from './customer-bff-fetch'
import { Country, CustomerGroup } from '../../..'

export const getCustomerGroup = async ({ customerGroupId, country }: { customerGroupId: string; country: Country }) => {
  const { data }: AxiosResponse<CustomerGroup> = await customerBffFetch(
    `/customer-group/${country}/${customerGroupId}`,
    {
      method: 'GET',
    },
  )
  return data
}

export const getGuestCustomerGroup = async (country: Country, email: string): Promise<CustomerGroup | null> => {
  try {
    const { data }: AxiosResponse<CustomerGroup> = await customerBffFetch(
      `/commercelayer/${country}/customers/customer_group`,
      {
        method: 'POST',
        data: { email },
      },
    )
    return data
  } catch {
    return null
  }
}
